import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthField } from '../../components/auth/AuthField';
import { AuthPageHeader } from '../../components/auth/AuthPageHeader';
import { AuthPageLayout } from '../../components/auth/AuthPageLayout';
import { requestPasswordReset } from '../../services/authApi';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await requestPasswordReset(email.trim());
      setSent(true);
      toast.success('Se o e-mail existir, enviaremos as instruções.');
    } catch {
      toast.error('Não foi possível solicitar a recuperação.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthPageLayout>
      <AuthPageHeader
        title="Recuperar senha"
        subtitle="Informe o e-mail cadastrado para receber o link de redefinição."
      />

      {sent ? (
        <p className="rounded-lg bg-primary-50 p-4 text-sm text-primary-800">
          Verifique sua caixa de entrada e siga as instruções do e-mail.
        </p>
      ) : (
        <form className="auth-form" onSubmit={(e) => void handleSubmit(e)}>
          <AuthField label="E-mail" htmlFor="email">
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              className="auth-field-input"
            />
          </AuthField>
          <button
            type="submit"
            disabled={submitting}
            className="erp-btn-primary w-full py-2.5"
          >
            {submitting ? 'Enviando...' : 'Enviar link'}
          </button>
        </form>
      )}

      <p className="mt-6 text-center text-sm text-secondary-500">
        <Link to="/login" className="font-medium text-primary-600 hover:text-primary-700">
          Voltar ao login
        </Link>
      </p>
    </AuthPageLayout>
  );
}
